<template>
  <div class="phone-number-wrapper">
    <input
      :class="{ 'is-invalid': isInvalid }"
      :placeholder="placeholder"
      :value="value"
      @input="onInput"
      class="form-control"
      v-on="listeners"
      v-bind="attrs"
      v-mask="mask"
    >
    <GText
      v-if="feedback && isInvalid"
      variant="caption"
      class="input-error"
      color="red-500"
    >
      {{ feedback }}
    </GText>
  </div>
</template>

<script>
import GText from '@trendyol-js/grace/core/GText';

export default {
  name: 'PhoneNumber',

  components: {
    GText,
  },

  props: {
    value: {
      type: [String, Number],
      default: '',
    },
    placeholder: {
      type: String,
      default: '0555 555 55 55',
    },
    mask: {
      type: String,
      default: '0999 999 99 99',
    },
    isInvalid: {
      type: Boolean,
      default: false,
    },
    feedback: {
      type: String,
      default: '',
    },
  },

  computed: {
    listeners () {
      const { input, ...listeners } = this.$listeners;

      return listeners;
    },

    attrs () {
      const { placeholder, ...attrs } = this.$attrs;

      return attrs;
    },
  },

  methods: {
    onInput (event) {
      this.$emit(
        'input',
        event.target.value.toString()
      );
    },
  },
};
</script>

<style lang="scss" scoped>
  input::placeholder {
    opacity: 0.5;
    font-size: 12px;
    color: #273142;
  }

  .input-error {
    margin-top: 5px;
    margin-left: 15px;
  }
</style>
